import { gql } from '@apollo/client';
import { Keyword } from '@app/utils/types';

export type PollResult = {
  documentId: string;
  option: string;
  votes: number;
  percentage: number;
};

export type PollOption = {
  documentId: string;
  option: string;
};

export type Poll = {
  poll: {
    documentId: string;
    question: string;
    title: string;
    isSinglePoll: boolean;
    isActive?: boolean;
    slug?: string;
    pollOptions: PollOption[];
    keywords: Keyword[];
  };
};

export type Polls = {
  polls: Poll['poll'][];
};

export const getPoll = gql`
  query GetPoll($pollId: ID!) {
    poll(documentId: $pollId) {
      documentId
      question
      title
      isSinglePoll
      pollOptions {
        documentId
        option
      }
      keywords {
        keyword
      }
    }
  }
`;

export const getSinglePoll = gql`
  query GetSinglePoll($slug: String!) {
    polls(filters: { slug: { eq: $slug } }) {
      documentId
      question
      title
      isSinglePoll
      isActive
      slug
      pollOptions {
        documentId
        option
      }
      keywords {
        keyword
      }
    }
  }
`;
